<template>
  <div class="form-container">
    <div class="menu-tab">
      <el-row>
        <el-button type="primary" size="mini" @click="exportXlsx"
          >导出</el-button
        >
        <!-- <el-button type="success" size="mini">取消全选</el-button>
        <el-button type="info" size="mini">删除</el-button> -->
        <el-select
          v-model="cateDetail"
          placeholder="选择分类"
          size="mini"
          class="m20"
          value-key="name"
          @change="changeForm"
        >
          <el-option
            v-for="item in cateList"
            :key="item.id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          size="mini"
          class="m20"
        >
        </el-date-picker>
        <el-button
          type="primary"
          size="mini"
          class="m10"
          @click="searchTime(true)"
          >搜索</el-button
        ><el-button
          type="primary"
          size="mini"
          class="m10"
          @click="searchTime(false)"
          >所有</el-button
        >
      </el-row>
    </div>
    <div id="xlsx-content-operation"></div>
  </div>
</template>
<script>
import XLSXConfig from "./config/config";
import DebugXlsxConfig from "./config/pollingDevice";
import Core from "@/libs/src/core";
import { xtos } from "@/utils/exportXlsx.js";
import * as XLSX from "xlsx";

const formType = {
  Repair: 0,
  Debug: 1,
};

const rowArr =
  "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,AA,AB,AC,AD,AE,AF,AG,AH,AI,AJ,AK,AL,AM,AN,AO,AP,AQ,AR,AS,AT,AU,AV,AW,AX,AY,AZ,BA,BB,BC".split(
    ","
  );

export default {
  data() {
    return {
      Loading: false,
      dialogVisible: false,
      labelPosition: "top",
      value2: "",
      dialogTableVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      cateDetail: {
        id: formType.Repair,
        name: "运维表",
      },
      cateList: [
        {
          id: formType.Repair,
          name: "运维表",
        },
        {
          id: formType.Debug,
          name: "巡检表",
        },
      ],
      urls: {
        addUrl: "api/CraftComponentCatalog",
        editUrl: "api/CraftComponentCatalog/%s",
      },
      filelist: [],
      formData: {
        name: "",
        CraftType: 0,
      },
      accept: "image/png, image/jpeg",
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      tableData: [],
      search: "",
      repairStatusEnum: {
        Send: "待领取", //0
        Way: "运维在途", //1
        Wait: "等待配件", //2
        Check: "待审核", //3
        Complete: "已完成", //4
        Third: "第三方维修",
      },
      repairTypeEnum: {
        Repair: "维修",
        Debug: "工艺",
      },
      allFormData: [],
      debugDatas: [],
    };
  },
  created() {
    this.sheet = Core.getProvider("Sheet");
    this.ops = Core.getProvider("DPC").operation;
    setTimeout(() => {
      this.initSheet();
    }, 0);
  },
  methods: {
    changeForm(val) {
      // 维修
      if (val.id == formType.Repair) {
        this.searchTime(false);
        // this.speadSheet.loadSheet();
      } else if (val.id == formType.Debug) {
        // 巡检
        this.setDebugForm(this.debugDatas);
        // this.speadSheet.loadData(JSON.parse(JSON.stringify(DebugXlsxConfig)));
      }
    },
    // 初始化表单
    async initSheet() {
      try {
        this.speadSheet = await this.sheet.createSheet(
          "#xlsx-content-operation"
        );
      } catch (error) {
        console.log(error);
      }
      // console.log(this.speadSheet);
      this.speadSheet.on("cell-selected", (cell, ri, ci) => {
        // console.log(cell, ri, ci);
        this.sheetRi = ri;
        this.sheetCi = ci;
      });

      // this.speadSheet.loadData(XLSXConfig);
      let RepairStatus = this.ops.RepairStatus;
      let formMap = new Map();
      //   派单中
      let allFormData = [];
      for (let key in RepairStatus) {
        let res = this.ops
          .getAllRepair({
            RepairStatus: RepairStatus[key],
          })
          .then((re) => {
            formMap.set(RepairStatus[key], re.data);
            return re.data;
          });

        allFormData.push(res);
      }
      Promise.all(allFormData).then((res) => {
        this.allFormData = res;
        let all = res.flatMap((item) => item.flatMap((da) => [da]));
        this.setXlsx(all);

      });
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.ops
        .getAllPatrolData()
        .then((res) => {
          loading.close();
          /**
           * @type {Array} debugList
           * @description 检修数据
           */
          let debugList = res.reverse();
          this.debugDatas = debugList;

          // this.setDebugForm(this.debugDatas);
        })
        .catch((err) => {
          loading.close();
        });
    },

    // 时间格式化
    formatDate(date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let minute = date.getMinutes();
      return y + "-" + m + "-" + d + " " + h + ":" + minute;
    },

    // 设置巡检表单
    setDebugForm(list) {
      let xlsxData = JSON.parse(JSON.stringify(DebugXlsxConfig));
      // console.log(list);
      // console.log(xlsxData);
      if (!list) {
        this.speadSheet.loadData(xlsxData);
        return;
      }
      // 过滤空数据
      let list2 = list.filter((item) => {
        if (
          item.devicePatrol.length > 0 ||
          item.productData.length > 0 ||
          item.techniquePatrol.length > 0
        ) {
          return item;
        }
      });
      // console.log("检修", list2);
      for (let i = 0, len = list2.length; i < len; i++) {
        let pIndex = i + 3;
        // 设备巡检
        let devicePatrol = list2[i].devicePatrol,
          // 生产数据
          productData = list2[i].productData,
          // 工艺巡检
          techniquePatrol = list2[i].techniquePatrol,
          // 水质分析
          waterAnalysis = list2[i].waterAnalysis;

        let setCell = (_list) => {
          for (let j = 0, len = _list.length; j < len; j++) {
            let index = rowArr.findIndex(
              (item) =>
                item.toLocaleUpperCase() == _list[j].key.toLocaleUpperCase()
            );
            if (!xlsxData[0].rows[pIndex]) {
              xlsxData[0].rows[pIndex] = {
                cells: {
                  0: {
                    text: this.formatDate(new Date(list2[i].dt)),
                  },
                  38:{
                    text:list2[i].createName
                  },
                  39:{
                    text:list2[i].projectName
                  }
                },
              };
            }
            xlsxData[0].rows[pIndex].cells[index] = {
              text: _list[j].displayData ?? "-",
            };
          }
        };

        Array.isArray(productData) && setCell(productData);

        Array.isArray(devicePatrol) && setCell(devicePatrol);

        Array.isArray(techniquePatrol) && setCell(techniquePatrol);

        Array.isArray(waterAnalysis) && setCell(waterAnalysis);

        // break;
      }
      this.speadSheet.loadData(xlsxData);
    },

    setXlsx(allFormData) {
      // console.log(allFormData)
      let xlsxData = JSON.parse(JSON.stringify(XLSXConfig));
      let rowList = [];
      let fixSuccessCount = 0,
        debugSuccessCount = 0;
      allFormData.forEach((snItem) => {
        let _Date = new Date(snItem.createTime);
        if (
          snItem.repairType == "Repair" &&
          snItem.repairStatus == "Complete"
        ) {
          fixSuccessCount++;
        }
        if (snItem.repairType == "Debug" && snItem.repairStatus == "Complete") {
          debugSuccessCount++;
        }
        let row = {
          cells: {
            0: {
              text: "",
              style: 0,
            },
            1: {
              text: `${_Date.getFullYear()}-${
                _Date.getMonth() + 1
              }-${_Date.getDate()}`,
              style: 0,
            },
            2: {
              text: snItem.projectName,
              style: 0,
            },
            3: {
              text: snItem.deviceName,
              style: 0,
            },
            4: {
              text: this.repairTypeEnum[snItem.repairType], // snItem.description,
              style: 0,
            },
            5: {
              text: snItem.faultCode,
              style: 0,
            },
            6: {
              text: snItem.createName,
              style: 0,
            },
            7: {
              text: snItem.receiverName,
              style: 0,
            },
            8: {
              text: this.repairStatusEnum[snItem.repairStatus],
              style: 0,
            },
            9: {
              text: "-",
              style: 0,
            },
          },
        };

        rowList.push(row);
      });

      rowList.forEach((row, index) => {
        row.cells[0].text = index + 1;
        xlsxData[0].rows[index + 6] = row;
      });

      xlsxData[0].rows[3].cells[0].text = "巡检完成：  -    单";
      xlsxData[0].rows[3].cells[4].text = `维修完成：  ${fixSuccessCount}    单`;
      xlsxData[0].rows[3].cells[7].text = `调试完成：  ${debugSuccessCount}    单`;

      this.speadSheet.loadData([...xlsxData]);
    },

    exportXlsx() {
      let data = this.speadSheet.getData();
      // console.log(data);
      // return;
      let newWb = xtos(data);
      let name = "巡检报表.xlsx";
      if (this.cateDetail.id == formType.repair) {
        name = "维修报表.xlsx";
      }
      XLSX.writeFile(newWb, name, {});
    },
    // 搜索日期
    searchTime(search) {
      let start = this.value2[0];
      let end = this.value2[1];

      // 维修数据
      let all = [];
      this.allFormData.forEach((item) => {
        item.forEach((da) => {
          if (search) {
            if (
              new Date(da.createTime) > start &&
              new Date(da.createTime) < end
            ) {
              all.push(da);
            }
          } else {
            all.push(da);
          }
        });
      });

      // 巡检数据
      let debugList = [];
      this.debugDatas.forEach((item) => {
        if (new Date(item.dt) > start && new Date(item.dt) < end) {
          debugList.push(item);
        }
      });

      if (this.cateDetail.id === formType.Repair) {
        this.setXlsx(all);
      } else if (this.cateDetail.id === formType.Debug) {
        // console.log(debugList, this.debugDatas);
        if (search) {
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.ops
            .getAllPatrolData({ BeginTime: start, EndTime: end })
            .then((res) => {
              /**
               * @type {Array} debugList
               * @description 检修数据
               */
              let List = res.reverse();
              loading.close();
              this.setDebugForm(List);
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          this.setDebugForm(this.debugDatas);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  padding: 20px;
  box-sizing: border-box;
}
.m10 {
  margin-left: 10px;
}
.m20 {
  margin-left: 20px;
}
#xlsx-content-operation {
  margin-top: 20px;
  height: calc(100vh - 100px);
  width: 100%;
  background: #ccc;
}
</style>